// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-Pf3Ejr","titleRow":"titleRow-bJxww1","titleGroup":"titleGroup-O7tbaP","actions":"actions-jkGruE","diffIndicator":"diffIndicator-KVXu9X"};